var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91153 3.49211C9.13869 3.53216 9.37264 3.50395 9.58377 3.41105C9.7949 3.31815 9.97375 3.16472 10.0977 2.97018C10.2216 2.77563 10.2851 2.5487 10.2801 2.31809C10.275 2.08747 10.2017 1.86353 10.0694 1.67458C9.9371 1.48562 9.75173 1.34015 9.53675 1.25654C9.32176 1.17294 9.08681 1.15497 8.86161 1.20489C8.63641 1.25482 8.43107 1.3704 8.27156 1.53703C8.11205 1.70366 8.00553 1.91385 7.96547 2.14101C7.93888 2.29184 7.94225 2.44644 7.9754 2.59597C8.00855 2.7455 8.07083 2.88703 8.15868 3.0125C8.24653 3.13796 8.35823 3.24489 8.4874 3.32718C8.61658 3.40947 8.76069 3.46551 8.91153 3.49211Z",
    fill: "#D7C0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08344 6.18571C7.24508 6.05499 7.24827 6.20704 6.93027 8.01055L5.80589 14.3872C5.53837 15.9044 7.67357 15.7874 9.49173 15.0524C9.56585 15.0239 9.62701 14.9693 9.66372 14.8989C9.70043 14.8285 9.71017 14.7471 9.6911 14.67C9.67204 14.5929 9.62548 14.5254 9.56017 14.4803C9.49487 14.4351 9.41531 14.4153 9.33645 14.4246C8.1748 14.5554 8.17161 14.4033 8.48962 12.5998L9.614 6.22311C9.88152 4.70594 7.74632 4.82291 5.92815 5.55795C5.85403 5.58645 5.79287 5.64104 5.75616 5.71145C5.71944 5.78187 5.7097 5.86327 5.72877 5.94036C5.74784 6.01745 5.7944 6.08492 5.85971 6.1301C5.92502 6.17528 6.00458 6.19505 6.08344 6.18571Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e5fe8f34a17190e84c82bfbc17500937.svg";
export { ForwardRef as ReactComponent };